import React from "react"
import CustomSlider from "../../atoms/Slider"

// const ThumbComponent = (props: any) => {
//   return (
//     <span {...props}>
//       <span className="bar" />
//       <span className="bar" />
//       <span className="bar" />
//     </span>
//   )
// }

export interface RangeSliderProps {
  value?: number[]
  defaultValue?: number[]
  onChange?: (value: number[]) => void
  min?: number
  max: number
}

const RangeSlider = ({ onChange, ...other }: RangeSliderProps) => {
  return (
    <CustomSlider
      onChange={(value) => onChange?.(value as number[])}
      {...other}
    />
  )
}

export default RangeSlider
